// extracted by mini-css-extract-plugin
export default {"itam":"SendModal_itam__cpPz7","block":"SendModal_block__OcJq0","blockbtn":"SendModal_blockbtn__qh3Dx","x":"SendModal_x__RHR1B","error":"SendModal_error__Pb8hW"};